import * as R from 'ramda'
import { caseType } from '@/modules/Case/helpers/case'

export const policyStatus: {
  [key: string]: string;
} = {
  EFFECTIVE: 'Effective',
  EXPIRED: 'Expired',
  ABOUT_TO_EXPIRE: 'About To Expire',
  CANCELLED: 'Cancelled',
  NO_ACTIVE: 'No Active',
  DELETED: 'Deleted'
}

export const statusKeys = R.keys(policyStatus)
export const statusValues = R.values(policyStatus)

export const policyStatusClass: {
  [key: string]: string;
} = {
  EFFECTIVE: 'c-policy-list__status-effective',
  EXPIRED: 'c-policy-list__status-expired',
  ABOUT_TO_EXPIRE: 'c-policy-list__status-about-to-expire',
  CANCELLED: 'c-policy-list__status-cancellation',
  NO_ACTIVE: 'c-policy-list__status-no-active',
  DELETED: 'c-policy-list__status-deleted'
}

export const policyStatusClassKeys = R.keys(policyStatusClass)
export const policyStatusClassValues = R.values(policyStatusClass)

export const policyType = caseType

export const policyTypeKeys = R.keys(policyType)
export const policyTypeValues = R.values(policyType)

export const policyPremiumStatus: {
  [key: string]: string;
} = {
  DEPOSITED: 'Deposited',
  INITIATED: 'Initiated',
  ON_HOLD: 'On Hold'
}

export const premiumStatusKeys = R.keys(policyPremiumStatus)
export const premiumstatusValues = R.values(policyPremiumStatus)

export const policyPremiumPaymentMethod: {
  [key: string]: string;
} = {
  CREDIT_CARD: 'Credit Card',
  CASH: 'Cash',
  QUICKBOOK: 'Quickbook',
  CLIENT_CHECKS: 'Client Checks',
  ACH: 'ACH'
}

export const paymentMethodKeys = R.keys(policyPremiumPaymentMethod)
export const paymentMethodValues = R.values(policyPremiumPaymentMethod)

export const policyCommissionPaymentMethod: {
  [key: string]: string;
} = {
  DIRECT_DEPOSIT: 'Direct Deposit',
  AGENCY_BILL_OBTAINED: 'Agency Bill Obtained',
  OTHER: 'Other'
}

export const commissionMethodKeys = R.keys(policyCommissionPaymentMethod)
export const commissionMethodValues = R.values(policyCommissionPaymentMethod)

export const billingType: {
  [key: string]: string;
} = {
  DIRECT_BILL: 'Direct Bill',
  AGENCY_DIRECT_BILL: 'Agency Direct Bill',
  AGENCY_BILL: 'Agency Bill',
  DIRECT_BILL_MORTGAGE: 'Direct Bill - Mortgage'
}

export const billingTypeKeys = R.keys(billingType)
export const billingTypeValues = R.values(billingType)

export const payerType: {
  [key: string]: string;
} = {
  BILL_INSURED: 'bill-insured',
  BILL_MORTGAGE: 'bill-mortgage'
}

export const payerTypeKeys = R.keys(payerType)
export const payerTypeValues = R.values(payerType)
